var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-btn',{staticClass:"round",attrs:{"color":"red","fab":"","height":"15em","width":"15em"},on:{"click":function($event){return _vm.handleClick()}}},[_vm._v("Click this button!")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }